import type { PageRole, ScanResult } from '../../utils/types';

/** `1 page` / `2 pages`: pluralised off the count, never a fixed plural. */
export function plural(n: number, word: string): string {
  return `${n} ${word}${n === 1 ? '' : 's'}`;
}

const POLICY_ROLES: readonly PageRole[] = ['policy', 'related-policy', 'dnss', 'policy-pdf'];
const SCANNED_ROLES: readonly PageRole[] = ['homepage', 'crawled', 'form-page'];

/**
 * The page counts the hero and Pages assessed both show (#1661), from one
 * place so they cannot disagree again.
 *
 * - `scanned` is the backend's `pagesScanned`: the pages the UI and tracker
 *   checks ran on. It is the hero's number.
 * - `policyRead` is the policy-side pages read in full that are not also a
 *   scanned page, so a homepage that doubles as the policy page counts once.
 *   `gpc-revisit` and `consent-sim` entries re-visit a page already counted
 *   and never add to either number.
 */
export function pageCounts(result: Pick<ScanResult, 'pagesScanned' | 'pageLedger'>): {
  scanned: number | null;
  policyRead: number;
} {
  const policyRead = (result.pageLedger?.visited ?? []).filter(
    (p) =>
      p.outcome === 'read' &&
      p.roles.some((r) => POLICY_ROLES.includes(r)) &&
      !p.roles.some((r) => SCANNED_ROLES.includes(r)),
  ).length;
  // Persisted JSON: a report without the field gets no scanned segment rather
  // than "undefined pages".
  const scanned = typeof result.pagesScanned === 'number' ? result.pagesScanned : null;
  return { scanned, policyRead };
}
